<template>
  <div>
    <!--页头-->
    <div class="header">
      <Menu></Menu>
    </div>
    <!--展示类容-->
    <div class="main">

      <!--   轮播图   -->
      <div>
        <van-swipe class="my-swipe" :autoplay="3000" :height="160">
          <van-swipe-item v-for="(image, index) in images" :key="index">
            <img v-lazy="image.img" style="width: 100%;height: 100%;"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!--      关于我们-->
      <div style="padding: 20px 15px 30px 15px;">
        <!-- 标题-->
        <div
            style="color: black;
                  text-align: center;
                  margin-bottom: 50px;
                  padding-top: 20px;
                  display: flex;
                  flex-direction: column;">
          <span style="font-size: 28px;
                        line-height: 30px;
                        height: 30px;
                        padding-bottom: 20px">关于我们
          </span>
          <em style="width: 40px;
                      height: 4px;
                      background: #000;
                      margin: auto;
                      display: inline-block;">
          </em>
        </div>
        <!--图片-->
        <div>
          <img :src="pic" alt="待加载..." style="width: 100%;">
        </div>
        <!--公司相关介绍-->
        <div style="padding: 0 19px;text-align: left;">
          <!--公司名称-->
          <h6 style="width: 100%;height: 50%;line-height: 40px;font-size: 24px;color: #7aa2cc">
            青豆（天津）科技有限公司</h6>
          <!--公司简介-->
          <div
              style="width: 100%;padding: 10px 0 15px;text-align: left;font-size: 18px;color: #D0D0D0;line-height: 165%;">
            企业至在以最先进的科学技术为核心，为各大企业做智能化、数字化服务。
          </div>
          <!--公司详情-->
          <p style="width: 100%;font-size: 14px;color: #666;line-height: 200%;margin-bottom: 10px">
            青豆科技公司成立于2018年，
            公司联合天津大学、南开大学、河北工业大学、航天二、三院等211、985的一流研发资源作为技术核心基础，
            从公司创建以来，一直参与研发来自高校、科研院所及国家重点项目的研发工作。
            团队成员分别来自于科研院所、日企、及欧美企业。团队成员从事研发工作十余年，
            一直接触前沿技术，团队专业性强，协作能力强。
            公司承诺会保质保量的完成任务，齐心协力共同进步。
          </p>
          <!--公司理念-->
          <span style="display: inline-block;
                        zoom: 1;
                        width: auto;
                        padding: 0 12px;
                        color: #FFF;
                        background: #7aa2cc;
                        height: 30px;
                        line-height: 30px;
                        border-radius: 10px;
                        -moz-border-radius: 10px;
                        -webkit-border-radius: 10px;">公司理念
          </span>
          <p style="width: 100%;
                    font-size: 14px;
                    color: #666;
                    line-height: 200%;
                    margin-bottom: 10px;">理念：诚信 务实 规范 共赢；
            <br>
            经营模式：以市场为导向，以生产为基础，以质量为后盾!
          </p>
          <!--涉及行业-->
          <span style="display: inline-block;
                        zoom: 1;
                        width: auto;
                        padding: 0 12px;
                        color: #FFF;
                        background: #7aa2cc;
                        height: 30px;
                        line-height: 30px;
                        border-radius: 10px;
                        -moz-border-radius: 10px;
                        -webkit-border-radius: 10px;">涉及行业
          </span>
          <p style="width: 100%;
                    font-size: 14px;
                    color: #666;
                    line-height: 200%;
                    margin-bottom: 10px;">
            技术开发；人工智能应用软件开发；计算机软硬件及辅助设备批发；电子产品销售；互联网设备销售；电子元器件制造。
          </p>
        </div>
      </div>

      <!--      产品展示-->
      <div style="padding: 30px 0px;background: #366dae">
        <!--产品展示标题-->
        <div style="color: #fff;text-align: center;">
          <span style="font-size: 28px;
                        line-height: 30px;
                        height: 30px;
                        display: block;
                        width: 100%;
                        overflow: hidden;
                        letter-spacing: 3px;
                        padding-bottom: 20px">
            产品展示</span>
          <em style="width: 40px;
                      height: 4px;
                      background: #fff;
                      margin: auto;
                      display: inline-block;">
          </em>
        </div>
        <!--相关产品-->
        <div style="padding: 20px 10px;margin-top: 15px">
          <van-grid :border="false" :column-num="1">
            <van-grid-item v-for="product in products" :key="product.id">
              <div style="width: 100%;margin-bottom: 10px;background: #F7F7F7;float: left;padding: 0px 5px">
                <div style="position: relative;
                            overflow: hidden;
                            cursor: pointer;
                            margin-top: 30px;"
                     v-for="(url,index) in product.commodity" :key="index">
                  <img v-if="index===0" :src="url.img" alt="待加载" style="top: 0;
                                                              right: 0;
                                                              bottom: 0;
                                                              left: 0;
                                                              max-width: 100%;
                                                              max-height: 100%;
                                                              display: block;
                                                              vertical-align: middle;
                                                              padding: 3% 0;
                                                              margin: auto;">
                </div>
                <div style="text-align: center;
                            padding: 10px;">
                  <p style="color: #3c3c3c;
                            font-size: 15px;
                            line-height: 25px;
                            height: 25px;
                            overflow: hidden;
                            width: 100%;">{{ product.name }}</p>
                  <!--跳转按键-->
                  <button class="product_button" @click="details(product.id)">查看详情>>></button>
                </div>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
      </div>

      <!--公司优势-->
      <div style="background: #F4F4F4;
                  padding-bottom: 30px;
                  padding-top: 20px;">
        <!--标题-->
        <div style="color: #000;
                    text-align: center;
                    margin-bottom: 50px;
                    padding-top: 20px;">
          <span style="font-size: 28px;
                        line-height: 30px;
                        display: block;
                        width: 100%;
                        overflow: hidden;
                        letter-spacing: 3px;
                        height: 30px;
                        padding-bottom: 20px">
            公司优势</span>
          <em style="width: 40px;
                      height: 4px;
                      background: #000;
                      margin: auto;
                      display: inline-block;"></em>
        </div>
        <!--相关标志-->
        <div style="background: #fff;
                    padding:1% 0;
                    margin-top: 3%;

                    width: 100%;">
          <ul style="display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 40px;">
            <li v-for="(icon,index) in icons" style="width: 25%;padding-bottom: 7%;">
              <img  :src="icon.picture" style="width: 20%"/>
              <h2 style="padding-top: 2%;font-size:calc(20 * 1.3rem / 40);">{{ icon.name }}</h2>
              <p style="padding-top: 2%;font-size:calc(20 * 1.3rem / 40);">{{ icon.synopsis }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--页脚-->
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Lazyload} from 'vant';
import Menu from './header/Index.vue';
import Footer from './footer/Index.vue';

Vue.use(Lazyload);


export default {
  components: {
    Menu,
    Footer
  },
  data() {
    return {
      products:[
        {
          id: '1',
          name: '高精度模拟信号采集',
          function: '高精度模拟数据的采集主要是通过模拟信号采集模块进行的，' +
              '这种模块能够同时采集电压或/和电流信号。' +
              '模块采用24位ADC，具有较高分辨率，内置低温漂的电流采样电阻，' +
              '并集成了电源和通信电气隔路，抗干扰能力强。这种模块支持8通道信号采集。',
          commodity:[
            {img:'./commodity/commodity1.png'},
            {img:'./commodity/commodity12.png'}
          ] ,
          details: '4-20mA / 0-20mA 信号采集 精度0.001mA',
          other: '',
        },
        {
          id: '2',
          name: 'FPGA试验箱-图像处理',
          function: 'FPGA试验盒是一种用于学习和实验的设备，' +
              '主要用于FPGA（现场可编程逻辑门阵列）的学习和实践。' +
              '它包含了FPGA开发板、实验板、下载器、相关配件等，' +
              '并提供丰富的实验资源，适用于通信、电子等教学和科研领域。',
          commodity:[
            {img:'./commodity/commodity12.png'}
          ] ,
          details: '试验箱型号：AQDX-7200T芯片：XC7A200T-2FBG484I内存：DDR3、4G配件' +
              '1、高速双目图像采集传感器800W像素' +
              '2、高帧率CMOS图像传感器，帧率可大100000帧' +
              '3、仿真器4、高速14bitDA采集模块，速率可达125M5',
          other: '',
        },

        {
          id: '3',
          name: '车规级四路高速图像采集卡',
          function: '车规级四路由高速图像采集卡是一种专门设计用于车辆应用的图像采集设备，' +
              '它能够在各种复杂环境下稳定工作，如高温、低温、湿度等极端条件。' +
              '这种采集卡通常具有高速数据传输、稳定性强、抗干扰能力强等特点，' +
              '能够满足车辆在行驶中对实时图像数据的高要求。',
          commodity:[
            {img:'./commodity/commodity3.png'}
          ] ,
          details: '四路高速并行LVDS采集卡，可实现4路1080P 60帧同时采集，' +
              '且不丢帧，具有多路缓存乒乓结构，每帧带ID发送。',
          other: '',
        },

        {
          id: '4',
          name: '八路高速3D扫描控制设备',
          function: '三维扫描技术主要用于获取物体的三维信息，' +
              '包括形状、尺寸、位置等，然后通过数据处理，对物体进行三维建模。' +
              '这种技术在高速轮胎扫描变形分析、病害检测等领域有广泛应用。',
          commodity:[
            {img:'./commodity/commodity6.png'}
          ] ,
          details: '高速轮胎扫描触发器',
          other: '',
        },
        /*{
          id: '5',
          name: '生产线远程分布式控制器',
          function: '生产线远程分布式控制系统主要是通过网络技术，' +
              '对生产线上的设备进行远程监控和控制，以提高生产效率和减少故障率。' +
              '分布式IO模块是实现远程分布式控制的关键技术之一，' +
              '它可以将测控领域中的状态信号，如温度、湿度、压力等，' +
              '通过分布式IO单元传递到各测测控领域进行实时控制。' +
              '分布式IO模块的应用，可以实现设备的分布式管理和控制，' +
              '提高生产效率，降低能耗和故障率。',
          commodity:[
            {img:'./commodity/commodity7.png'}
          ] ,
          details: '多设备集成控制器可替代PLC',
          other: '',
        },
        {
          id: '6',
          name: '特种光源',
          function: '特种光源，主要用于在印刷、彩色印刷等过程中，' +
              '用于印刷、非银盐负片、重氮盐薄膜、薄膜、树脂板、PS版的UV光硬化，' +
              '也可用于印刷锡和其他表面涂层。',
          commodity:[
            {img:'./commodity/commodity8.png'}
          ] ,
          details: '大功率UV灯',
          other: '',
        },
        {
          id: '7',
          name: '芯片包装机高速控制板',
          function: '芯片包装机是一种专门用于包装芯片的设备，' +
              '高速控制板则是其重要的组成部分，主要负责控制设备的运行速度和精度。',
          commodity:[
            {img:'./commodity/commodity10.png'}
          ] ,
          details: '高速控制板的功能强大、性能可靠，可以与各种设备和系统进行集成，' +
              '可以与各种传感器和执行器配合使用。',
          other: '',
        },
        {
          id: '8',
          name: '远程管道腐蚀检测控制板',
          function: '远程管道腐蚀监测系统是一种利用先进技术对管道腐蚀情况进行远程实时监测的系统，' +
              '主要针对压电超声耦合、传感器的安装、信号的传输存储分析等问题进行研究。',
          commodity:[
            {img:'./commodity/commodity11.png'}
          ] ,
          details: '可以实现对腐蚀情况的远程实时监测，从而提高管道的安全性和使用寿命。',
          other: '',
        },*/
        /*{
          id: '9',
          name: '远程数据采集卡',
          function: '',
          commodity:[
        {img:'./commodity/commodity13.png'}
    ] ,
          details: '',
          other: '',
        },*/

        /*{
          id: '10',
          name: '工业IOT网关',
          function: '工业物联网网关（IoT Gateway）是工业物联网的关键组成部分，' +
              '主要用于连接工业设备和云端，实现设备间和设备与云的高效通信与交互。' +
              '它充当着数据的采集、传输、存储和处理的桥梁，' +
              '可以处理来自不同设备、不同网络和不同环境的海量数据，' +
              '将这些数据转换成统一的格式，以便于集中管理和分析。',
           commodity:[
        {img:'./commodity/commodity14.png'}
    ] ,
          details: '该产品是一款ce、防爆/煤安全认证的产品，可以满足现场复杂工况，' +
              '具有多种通信方式（包括以太网，wifi，5g通信和无线智能传感网）。' +
              '它可以与无线传感器（如inl3334，inl3364，inl4334等）组合使用。' +
              '该产品的核心是inl3000无线网关，可以与无线智能设备（如inl4304，inl5304等）组合。',
          other: '',
        },*/
        /*{
          id: '11',
          name: '高精度比例阀控制板',
          function: '',
          commodity:[
        {img:'./commodity/commodity2.png'}
    ] ,
          details: '',
          other: '',
        },*/
      ],
      pic: './picture.png',
      images: [
        {img: './lun/poster1.jpg',},
        {img: './lun/poster2.jpg',},
        {img: './lun/poster3.jpg',},
        {img: './lun/poster4.jpg',},
      ],
      icons: [
        {
          picture: './icon/icon1.png',
          name: '专业专注',
          synopsis: '研发工作十余年'
        },
        {
          picture: './icon/icon2.png',
          name: '品质保证',
          synopsis: '原厂一手货源'
        },
        {
          picture: './icon/icon3.png',
          name: '技术支持',
          synopsis: '专业工程师团队'
        },
        {
          picture: './icon/icon4.png',
          name: '打包服务',
          synopsis: '可提供一站式打包服务'
        },
      ],
    }
  },
  methods:{
    details(id){
      this.$router.push({path: '/details/'+id})
    },
  },
}
</script>

<style scoped>

.header {
  background: white;
  width: 100%;
  height: 66px;
}

.main {
  width: 100%;
}

.product_button {
  color: #0666d9;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 12px;
  line-height: 20px;
  height: 20px;
  overflow: hidden;
  text-decoration: none;
}

.product_button:focus {
  outline: none;
}

.footer {

}

</style>